"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _Functions = require("../core/Functions");

var _AlertConstants = require("./AlertConstants");

var newFloatingAlertStore = function newFloatingAlertStore() {
  var alertId = 0;
  var alerts = {};
  var subscriptions = {};

  var alertsToArray = function alertsToArray() {
    return Object.keys(alerts).map(function (alertKey) {
      return alerts[alertKey];
    });
  };

  var setAlerts = function setAlerts(nextAlerts) {
    alerts = nextAlerts;
    var alertArray = alertsToArray();
    Object.keys(subscriptions).forEach(function (key) {
      subscriptions[key](alertArray);
    });
  };

  return {
    getAlerts: function getAlerts() {
      return alerts;
    },
    getSubscriptions: function getSubscriptions() {
      return subscriptions;
    },
    subscribe: function subscribe(key, updateCallback) {
      (0, _invariant.default)(!subscriptions[key], "FloatingAlertStore: key: `" + key + "` already subscribed");
      subscriptions[key] = updateCallback;
      updateCallback(alertsToArray());
    },
    unsubscribe: function unsubscribe(key) {
      if (subscriptions[key]) {
        var newSubscriptions = (0, _extends3.default)({}, subscriptions);
        delete newSubscriptions[key];
        subscriptions = newSubscriptions;
      } else {
        _devLogger.default.warn({
          message: "FloatingAlertStore: Could not find key: `" + key + "` to unsubscribe"
        });
      }
    },
    addAlert: function addAlert(_ref) {
      var _this = this;

      var _ref$id = _ref.id,
          id = _ref$id === void 0 ? "Store-" + alertId++ : _ref$id,
          sticky = _ref.sticky,
          timeout = _ref.timeout,
          _ref$timestamp = _ref.timestamp,
          timestamp = _ref$timestamp === void 0 ? Date.now() : _ref$timestamp,
          type = _ref.type,
          _onClose = _ref.onClose,
          alert = (0, _objectWithoutProperties2.default)(_ref, ["id", "sticky", "timeout", "timestamp", "type", "onClose"]);
      var newAlert = (0, _extends3.default)({}, alert, {
        id: id,
        onClose: function onClose() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _Functions.callIfPossible.apply(void 0, [_onClose].concat(args));

          _this.removeAlert(id);
        },
        timestamp: timestamp,
        type: type
      });
      setAlerts((0, _extends3.default)({}, alerts, (0, _defineProperty2.default)({}, id, newAlert)));

      if (!sticky && type !== 'danger') {
        var alertTimeout = timeout != null ? timeout : _AlertConstants.FLOATING_ALERT_DEFAULT_TIMEOUT;
        setTimeout(function () {
          _this.removeAlert(id);
        }, alertTimeout);
      }
    },
    removeAlert: function removeAlert(id) {
      var newAlerts = (0, _extends3.default)({}, alerts);
      delete newAlerts[id];
      setAlerts(newAlerts);
    }
  };
}; // Workaround to avoid mixed exports, but still have access to a generator
// function for ease of testing.


var FloatingAlertStore = newFloatingAlertStore();
FloatingAlertStore.newFloatingAlertStore = newFloatingAlertStore;
var _default = FloatingAlertStore;
exports.default = _default;
module.exports = exports.default;